import { useTranslation } from 'react-i18next';

import { Chip, ChipIconPosition, ChipVariant } from '@indicia/component-library';
import useBem from '@indicia/use-bem';

import Icon from '../../../../shared/components/button/enums/Icon';

import './StateChip.scss';

type StateChipProps = {
  isCompliment: boolean;
};

const StateChip = ({ isCompliment }: StateChipProps) => {
  const { t } = useTranslation();
  const { bemClassName, bemClassNames } = useBem('chip-container');
  const iconPosition = ChipIconPosition.left;

  const isPositive = Boolean(isCompliment);
  const stateClass = isPositive ? 'status-positive' : 'status-negative';
  const label = isPositive ? t('dashboard.category-status.positive') : t('dashboard.category-status.negative');
  const iconName = isPositive ? Icon.checkboxRound : Icon.alert;

  return (
    <div className={bemClassNames([bemClassName('chip'), bemClassName(null, stateClass, true)])}>
      <Chip
        variant={ChipVariant.filled}
        label={label}
        iconName={iconName}
        iconPosition={iconPosition}
      />
    </div>
  );
};

export default StateChip;
